import toast from 'react-hot-toast'
import { AxiosError } from 'axios'

import {
  Container,
  Generic,
  Pallet,
  Product,
  makeGeneric,
  CarrierType,
} from 'src/api/models'
import { skuit } from 'src/services/skuit'

import { Handler, HandlerInput } from './base'
import { Action, ApplyScan } from './interface'

interface LabelPrintingHandlerInput extends HandlerInput {
  obj: Generic
}

export class CaseLabelPrintingHandler extends Handler {
  obj: Generic
  container?: Generic
  shipmentUnit?: Generic
  product?: Generic

  constructor(props: LabelPrintingHandlerInput) {
    super(props)
    this.obj = props.obj
  }

  apply = ({ scanned, context, local }: ApplyScan): [Action, any | undefined] => {
    switch (scanned.object.type) {
      case Pallet.type:
      case Container.type: {
        if (this.forParcelCarrier) return [Action.Invalid, undefined]

        skuit.sc.freight.shipments.pallets.retrieve(this.obj.object.guid, scanned.object.guid)
          .then((container) => {
            if (container.guid !== this.container?.guid) {
              this.shipmentUnit = undefined
              this.product = undefined
            }
            this.container = makeGeneric(container)
            this.notify({})
          })
          .catch((error: AxiosError) => {
            toast.error(`Invalid container. "${error.response?.data}"`)
          })
        return [Action.Invalid, undefined]
      }
      case Product.type: {
        if (!this.container && !this.forParcelCarrier) return [Action.Invalid, undefined]

        skuit.sc.freight.shipments.units.list({
          params: {
            shipments: this.obj.object.guid,
            containers: this.container?.guid,
            products: scanned.object.guid
          }
        })
          .then((shipmentUnits) => {
            if (shipmentUnits.results.length === 0) {
              toast.error("Invalid product.")
              return
            }
            this.shipmentUnit = makeGeneric(shipmentUnits.results[0])
            this.product = makeGeneric(scanned.object)
            this.notify({})
          })
          .catch((error: AxiosError) => {
            toast.error(`Invalid product. "${error.response?.data}"`)
          })
        return [Action.Invalid, undefined]
      }
    }
    return [Action.Invalid, undefined]
  }

  printed = () => {
    if (this.container && this.product) {
      skuit.sc.freight.shipments.units.markPrinted(this.obj.object.guid, this.container.object.guid, this.product.object.guid)
    }
    this.product = undefined
    this.shipmentUnit = undefined
    this.notify({})
  }

  getContext = () => {
    return { activity: 'label_printing', obj: this.obj.object.guid }
  }

  get forParcelCarrier(){
    return this.obj.object.carrier?.carrierType === CarrierType.parcel
  }
}
